import { addDays } from "date-fns";
import { AvailableDepositBonusesList } from "../models/response/availableDepositBonusesResponse";
import { Button } from "../../../components/ui";
import { BLOB_IMAGE_URL } from "../../../config/appConfig";
import { BlobContainerConsts } from "../../../models/constants/blobContainerConsts";
import localization from "../../../config/localization";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import {
  formatDateTime,
  formatUtcToLocalDateTime,
} from "../../../utils/dateTimeHelper";

interface BonusInfoModalProps {
  bonus: AvailableDepositBonusesList;
  languageCode: string;
  appliedBonusId: string | null;
  onClose: () => void;
  onApply: (bonusId: string) => void;
}

export default function BonusInfoModal({
  bonus,
  languageCode,
  appliedBonusId,
  onClose,
  onApply,
}: BonusInfoModalProps) {
  const isApplied = appliedBonusId === bonus.id;

  const expiryDate = formatDateTime(
    addDays(new Date(), bonus.bonusvalidclaimingdays),
    false
  );

  const claimUntilDate = formatUtcToLocalDateTime(bonus.todate, false);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70">
      <div className="relative w-[380px] rounded-2xl bg-white overflow-hidden">
        <Button
          className="text-[#838383] h-6 w-6 rounded-full bg-[#F2F2F2] absolute top-4 right-4"
          onClick={onClose}
        >
          <FontAwesomeIcon icon={faXmark} size="sm" className="mt-1.5" />
        </Button>

        <img
          src={`${BLOB_IMAGE_URL}${BlobContainerConsts.DepositBonus}/${bonus.depositbonusimage}`}
          alt={bonus.bonusname}
          className="w-full h-48 object-cover rounded-t-xl"
        />

        <div className="p-5">
          <h2 className="text-xl text-black leading-[22px] font-semibold">
            {bonus.bonusname}
          </h2>

          <p className="text-sm text-[#5D5D5D] font-medium mt-4 leading-5">
            {languageCode === "en-US"
              ? bonus.bonusdescription
              : bonus.bonushindidescription}
          </p>

          <p className="text-sm font-semibold text-[#B31313] leading-[10px] mt-4">
            {isApplied
              ? `${localization.expires}: ${expiryDate}`
              : `${localization.claim_until}: ${claimUntilDate}`}
          </p>

          <Button
            onClick={() => onApply(bonus.id)}
            className={`w-full mt-6 py-3 rounded-[4px] text-white text-sm font-medium bg-secondary-gradient`}
          >
            {isApplied && (
              <img
                src={"/icons/ic-applied.svg"}
                alt="applied"
                className="w-4 h-4 inline-block mr-2"
              />
            )}
            {isApplied ? localization.applied : localization.apply_bonus}
          </Button>
        </div>
      </div>
    </div>
  );
}
